import PrimeIndiaVpnSettings from "../../Prime/PrimeIndiaVpnSettings";

const MobilePrimeIndiaVpnSettings = () => {
  return <PrimeIndiaVpnSettings isMobile />;
};

export default MobilePrimeIndiaVpnSettings;
